import { INTERNAL_SESSION_START } from "../constants/events";
import storeRTK from "../store/storeRTK";
import { initializeNotifications } from "../connector/notifications";
import Emitter from "../emitter";

export function notificationInitialiseHandler() {
  storeRTK.dispatch(initializeNotifications(null));
}

export default function registerNotificationHandlers() {
  Emitter.on(INTERNAL_SESSION_START, notificationInitialiseHandler);
}
